
import { Component, Vue, Prop } from 'vue-property-decorator';
import { customerOrderList, customerOrderExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';

const orderStatusOptions = [{
  value: '2',
  label: '未处理'
}, {
  value: '3',
  label: '进行中'
}, {
  value: '4',
  label: '已完成'
}];

@Component({
  name: 'StatisticsScustomerDetail',
  components: {
  }
})
export default class extends Vue {
  private formSearch: any = {
    timePeriods: '',
    orderStatus: '',
    mode: ''
  }
  private pickerOptions:any = {
    disabledDate(time: any) {
      let y = new Date().getFullYear();
      let m = new Date().getMonth();
      let d = new Date().getDate();
      return time.getTime() >= new Date(y, m, d, 0, 0, 0);
    }
  }

  private orderStatusOptions = orderStatusOptions

  private customer:any={}
  created() {
    this.customer = JSON.parse(this.$route.query.customer as string);
    this.getList();
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList()
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList()
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private loading = false
  private tableData = []
  private detailHandle(val:any) {
    // 展示详情;
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.id,
        company_id: UserModule.getCompanyId,
      }
    });
    window.open(routeData.href);
  }

  // 导出Excel
  private handleExport() {
    let customerId:any = '';
    if (parseInt(this.customer.customer_company_id) === 0 || !this.customer.customer_company_id) {
      customerId = 'p' + this.customer.user_id;
    } else {
      customerId = this.customer.customer_company_id;
    }
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      customer_id: customerId,
      customer_name: this.customer.name
    };
    if (this.formSearch.orderStatus) {
      params.order_state = this.formSearch.orderStatus;
    }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = this.formSearch.timePeriods[0] / 1000;
      params.end_time = this.formSearch.timePeriods[1] / 1000;
    }
    customerOrderExport(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  getList() {
    let customerId:any = '';
    if (parseInt(this.customer.customer_company_id) === 0 || !this.customer.customer_company_id) {
      customerId = 'p' + this.customer.user_id;
    } else {
      customerId = this.customer.customer_company_id;
    }
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      customer_id: customerId
    };
    if (this.formSearch.orderStatus) {
      params.order_state = this.formSearch.orderStatus;
    }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = this.formSearch.timePeriods[0] / 1000;
      params.end_time = this.formSearch.timePeriods[1] / 1000;
    }
    this.loading = true;
    customerOrderList(params).then(res => {
      if (res.data) {
        this.pagination.total = parseInt(res.data.count);
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }

      this.loading = false;
    }).catch(err => {
      if (err && !err.data) {
        this.tableData = [];
        this.loading = false;
      }
    });
  }

  handleDetails(row: any) {
    this.$router.push({
      path: 'details',
      query: {
        sid: row.servicer_company_id
      }
    });
  }

  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  handleClear() {
    this.formSearch = {
      timePeriods: '',
      orderStatus: '',
      mode: ''
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
